var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { broadcastTransaction, getAccount, getTransactionParams } from "./algodv2";
import { getAccountTransactions } from "./indexer";
export * from "./algodv2.types";
export * from "./indexer.types";
export class AlgorandAPI {
    constructor(network) {
        this.network = network;
    }
    getAccount(address) {
        return __awaiter(this, void 0, void 0, function* () {
            return getAccount(this.network)(address);
        });
    }
    getTransactionParams() {
        return __awaiter(this, void 0, void 0, function* () {
            return getTransactionParams(this.network)();
        });
    }
    broadcastTransaction(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return broadcastTransaction(this.network)(payload);
        });
    }
    getAccountTransactions(address, startAt) {
        return __awaiter(this, void 0, void 0, function* () {
            return getAccountTransactions(this.network)(address, startAt);
        });
    }
}
//# sourceMappingURL=index.js.map